"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _OutputString = _interopRequireDefault(require("./type/OutputString"));
var _OutputDate = _interopRequireDefault(require("./type/OutputDate"));
var _OutputBoolean = _interopRequireDefault(require("./type/OutputBoolean"));
var _OutputImage = _interopRequireDefault(require("./type/OutputImage"));
var _OutputPointer = _interopRequireDefault(require("./type/OutputPointer"));
var _excluded = ["type", "_type", "field", "object"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputFactory/index.js";
var outputComponents = {
  Email: _OutputString["default"],
  String: _OutputString["default"],
  Text: _OutputString["default"],
  Number: _OutputString["default"],
  Tel: _OutputString["default"],
  Enum: _OutputString["default"],
  Boolean: _OutputBoolean["default"],
  Date: _OutputDate["default"],
  Image: _OutputImage["default"],
  Pointer: _OutputPointer["default"]
};
function OutputFactory(_ref) {
  var type = _ref.type,
    _type = _ref._type,
    field = _ref.field,
    object = _ref.object,
    options = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Component = outputComponents[_type] || outputComponents[type]; // Check _type first, fallback to type
  if (Component) {
    return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
      field: field,
      object: object
    }, options, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 16
      }
    }));
  }
  if (type === 'Component') {
    return object[field];
  }
  return null;
}
var _default = OutputFactory;
exports["default"] = _default;